import axiosInstance from "./api_helper";

const stockService = {
    search: async ({ query = '', page = 0, size = 10, productId = null }) => {
        const params = { query, page, size };
        if (productId) {
            params.productId = productId;
        }
        return axiosInstance.get('/api/stocks/search', { params });
    },
    delete: async (id) => {
        return axiosInstance.delete(`/api/stocks/${id}`);
    },
    save: async (stock) => {
        return axiosInstance.post(`/api/stocks`, JSON.stringify(stock));
    },
    update: async (payload) => {
        return axiosInstance.put(`/api/stocks/${payload.id}`, JSON.stringify(payload.stock));
    },

};
export default stockService;
